//URL SITIO DEL BACKEND
 //DESARROLLO....
//const API_URL = 'http://localhost:5458'; // Reemplaza con la URL de tu API

///AZURE
const API_URL = 'https://datamunibe-gubnbkf4a9b9bchg.mexicocentral-01.azurewebsites.net'; // Reemplaza con la URL de tu API
export default API_URL;